import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useLiabilityFieldVisibility } from "@Client/@Composables/application-standalone/pages/liabilities/useLiabilityFieldVisibility";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import i18n from "@Shared/@i18n";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { computed, ref } from "@vue/composition-api";
export const useLiabilityHelpers = () => {
  const {
    addNestedField,
    removeNestedField
  } = useBindApplication();
  const {
    applicantsAsOptions: applicantsAsOptionsFromHelper,
    applicationHasCoApplicants,
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const liabilitiesPath = "[liabilities]";
  const addEmptyLiability = applicantIndex => {
    const rootPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    addNestedField(rootPath + liabilitiesPath);
  };
  const deleteLiability = (applicantIndex, liabilityIndex) => {
    const rootPath = applicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : APPLICATION_PATH.CO_APPLICANTS + `[${applicantIndex - 1}]`;
    removeNestedField(rootPath + liabilitiesPath, liabilityIndex);
  };
  const liabilitySummarySubtitle = liability => {
    var _liability$balance;
    const liabilityInfo = [];
    if (liability.type) liabilityInfo.push(i18n.t(`application-form.${liability.type}`).toString());
    const balance = (_liability$balance = liability.balance) == null ? void 0 : _liability$balance.toString();
    if (_parseFloat(balance)) liabilityInfo.push(formatMoneyValueLong(balance));
    return liabilityInfo.join(" | ");
  };
  const applicantHasLiabilities = liabilities => (liabilities == null ? void 0 : liabilities.length) > 0;
  const isLiabilitySectionVisibleForMainApplicant = computed(() => {
    const {
      isLiabilitySectionVisibleForApplicant
    } = useLiabilityFieldVisibility({
      applicantIndex: ref(0),
      liabilityIndex: ref(0)
    });
    return isLiabilitySectionVisibleForApplicant.value;
  });
  const isLiabilitySectionVisibleForCoApplicants = computed(() => {
    if (!applicationHasCoApplicants.value) return false;
    const {
      isLiabilitySectionVisibleForApplicant
    } = useLiabilityFieldVisibility({
      applicantIndex: ref(1),
      liabilityIndex: ref(0)
    });
    return isLiabilitySectionVisibleForApplicant.value;
  });
  const filteredApplicantsAsOptions = computed(() => {
    const [mainApplicant, ...coApplicants] = applicantsAsOptionsFromHelper.value;
    const filteredApplicants = [];
    if (isLiabilitySectionVisibleForMainApplicant.value) filteredApplicants.push(mainApplicant);
    if (isLiabilitySectionVisibleForCoApplicants.value) filteredApplicants.push(...coApplicants);
    return _filterInstanceProperty(filteredApplicants).call(filteredApplicants, ({
      id
    }) => isApplicantVisibleFromFillOut(id));
  });
  return {
    addEmptyLiability,
    deleteLiability,
    liabilitySummarySubtitle,
    applicantHasLiabilities,
    isLiabilitySectionVisibleForMainApplicant,
    isLiabilitySectionVisibleForCoApplicants,
    filteredApplicantsAsOptions
  };
};